export default {
  fade: {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  zoom: {
    enterClass: 'zoomInDown',
    leaveClass: 'zoomOutUp'
  },
  zoomInOut: {
    enterClass: 'zoomIn',
    leaveClass: 'zoomOut'
  },
  bounce: {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutUp'
  },
  slide: {
    enterClass: 'bounceIn',
    leaveClass: 'bounceOut'
  },
  flowRight: {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  flowLeft: {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  fadeDown: {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutUp'
  },
  fadeInOutRight: {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutRight'
  }
}



// WEBPACK FOOTER //
// ./src/transitions.js